import isBTC from '~/client/hooks/currency/helpers/isBTC';

const areBothBTC = (from: string, to: string) => isBTC(from) && isBTC(to);

export default areBothBTC;
